import React from 'react';
import { string, element } from 'prop-types';
import { Link } from 'react-router-dom';
import Wrapper from '../Wrapper';

// The purpose of this component is to enable the ability of
// opening its content in a new tab on desktop web
// but remaining in the current tab on mobile web
const LinkWrapper = ({ id, className, href, children }) => (
  <>
    <Wrapper id={id} className={className} display={['none', 'block']}>
      <a href={href} rel="noopener noreferrer" target="_blank">
        {children}
      </a>
    </Wrapper>
    <Wrapper
      id={id}
      className={`${className}-mobile`}
      display={['block', 'none']}
    >
      <Link to={href}>{children}</Link>
    </Wrapper>
  </>
);

LinkWrapper.propTypes = {
  id: string,
  className: string,
  href: string,
  children: element,
};

export default LinkWrapper;
